module.exports = __webpack_public_path__ + "files/8ab3f9f2e2c217d41782cac48f7d4187.png";